/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScreeningFlowMatch } from './InternalApiScreeningFlowMatch';
import {
    InternalApiScreeningFlowMatchFromJSON,
    InternalApiScreeningFlowMatchFromJSONTyped,
    InternalApiScreeningFlowMatchToJSON,
    InternalApiScreeningFlowMatchToJSONTyped,
} from './InternalApiScreeningFlowMatch';
import type { InternalApiEntityType } from './InternalApiEntityType';
import {
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeFromJSONTyped,
    InternalApiEntityTypeToJSON,
    InternalApiEntityTypeToJSONTyped,
} from './InternalApiEntityType';
import type { InternalApiScreeningFlowList } from './InternalApiScreeningFlowList';
import {
    InternalApiScreeningFlowListFromJSON,
    InternalApiScreeningFlowListFromJSONTyped,
    InternalApiScreeningFlowListToJSON,
    InternalApiScreeningFlowListToJSONTyped,
} from './InternalApiScreeningFlowList';
import type { InternalApiScreeningFlowGoodlist } from './InternalApiScreeningFlowGoodlist';
import {
    InternalApiScreeningFlowGoodlistFromJSON,
    InternalApiScreeningFlowGoodlistFromJSONTyped,
    InternalApiScreeningFlowGoodlistToJSON,
    InternalApiScreeningFlowGoodlistToJSONTyped,
} from './InternalApiScreeningFlowGoodlist';

/**
 * 
 * @export
 * @interface InternalApiScreeningFlow
 */
export interface InternalApiScreeningFlow {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningFlow
     */
    id?: string;
    /**
     * 
     * @type {InternalApiEntityType}
     * @memberof InternalApiScreeningFlow
     */
    entityType: InternalApiEntityType;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningFlow
     */
    field: string;
    /**
     * 
     * @type {InternalApiScreeningFlowGoodlist}
     * @memberof InternalApiScreeningFlow
     */
    goodList?: InternalApiScreeningFlowGoodlist;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiScreeningFlow
     */
    includedSegments?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiScreeningFlow
     */
    excludedSegments?: Array<string>;
    /**
     * 
     * @type {InternalApiScreeningFlowMatch}
     * @memberof InternalApiScreeningFlow
     */
    match: InternalApiScreeningFlowMatch;
    /**
     * 
     * @type {Array<InternalApiScreeningFlowList>}
     * @memberof InternalApiScreeningFlow
     */
    lists?: Array<InternalApiScreeningFlowList>;
}



/**
 * Check if a given object implements the InternalApiScreeningFlow interface.
 */
export function instanceOfInternalApiScreeningFlow(value: object): value is InternalApiScreeningFlow {
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('match' in value) || value['match'] === undefined) return false;
    return true;
}

export function InternalApiScreeningFlowFromJSON(json: any): InternalApiScreeningFlow {
    return InternalApiScreeningFlowFromJSONTyped(json, false);
}

export function InternalApiScreeningFlowFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningFlow {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'entityType': InternalApiEntityTypeFromJSON(json['entityType']),
        'field': json['field'],
        'goodList': json['goodList'] == null ? undefined : InternalApiScreeningFlowGoodlistFromJSON(json['goodList']),
        'includedSegments': json['includedSegments'] == null ? undefined : json['includedSegments'],
        'excludedSegments': json['excludedSegments'] == null ? undefined : json['excludedSegments'],
        'match': InternalApiScreeningFlowMatchFromJSON(json['match']),
        'lists': json['lists'] == null ? undefined : ((json['lists'] as Array<any>).map(InternalApiScreeningFlowListFromJSON)),
    };
}

export function InternalApiScreeningFlowToJSON(json: any): InternalApiScreeningFlow {
    return InternalApiScreeningFlowToJSONTyped(json, false);
}

export function InternalApiScreeningFlowToJSONTyped(value?: InternalApiScreeningFlow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'entityType': InternalApiEntityTypeToJSON(value['entityType']),
        'field': value['field'],
        'goodList': InternalApiScreeningFlowGoodlistToJSON(value['goodList']),
        'includedSegments': value['includedSegments'],
        'excludedSegments': value['excludedSegments'],
        'match': InternalApiScreeningFlowMatchToJSON(value['match']),
        'lists': value['lists'] == null ? undefined : ((value['lists'] as Array<any>).map(InternalApiScreeningFlowListToJSON)),
    };
}

